module.exports = __webpack_public_path__ + "static/media/folha3.55ad848b.png";